import makeRequest from './request';
import {
    BASE_URL_ADMIN
} from './data/config';

function get_room_types(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/roomType/getRoomType`, params)
}

function upload_image(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/upload-image`, params, {
        'Content-Type': 'multipart/form-data'
    })
}

function create_quote(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/quote/new`, params)
}

function update_quote(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/quote/update`, params)
}

function get_quote_by_id(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/quote/get`, params)
}

function update_price_item_vendor(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/vendor/updatePriceItem`, params)
}

function update_price_item_quote_vendor(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/vendor/updateItemQuotes`, params)
}

function add_item_quote_vendor(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/vendor/addItemQuote`, params)
}

function get_all_group(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/roomType/getGroup`, params);
}

function get_contractor_by_group(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getContractor`, params);
}

function get_designer(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getDesigner`, params);
}

function get_pm(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getPm`, params);
}

function get_items_of_quotes(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/quote/getItemOfQuotes`, params);
}

function get_items_vendor(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getItems`, params);
}

function get_items_vendor_pagination(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getItemsPagination`, params);
}

function vendor_sign_in(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/vendor/login`, params);
}

function get_vendor_by_token(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/verify`, params);
}

function get_quote_of_vendor(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getQuotes`, params);
}

function get_live_bid_of_designer(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getQuotesDesigner`, params);
}

function get_live_bid_of_pm(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getLiveBidPm`, params);
}

function get_contractor_quote_detail(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/quote/getQuotesContractor`, params);
}

function get_items_vendor_group(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getItemsVendorAdd`, params);
}

function vendor_accept_quote(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/vendor/acceptQuote`, params);
}

function vendor_decline_quote(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/vendor/declineQuote`, params);
}

function check_quote_vendor_state(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/checkState`, params);
}

function get_contractor_detail(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getContractorDetail`, params)
}

function update_contractor_detail(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/vendor/contractorUpdate`, params)
}

function vendor_get_projects(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getProjects`, params)
}

function designer_get_projects(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getProjectsDesigner`, params)
}

function pm_get_projects(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getProjectsPm`, params)
}

function get_all_designer_items(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getAllDesignerItem`, params)
}

function get_designer_items_to_add(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getDesignerItemAdd`, params)
}

function get_all_category_items(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getCategoryItem`, params)
}

function add_new_quote_designer_item(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/vendor/addNewQuoteDesignerItem`, params)
}

function get_quote_designer_items(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getQuoteDesignerItems`, params)
}

function remove_quote_designer_item(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/vendor/removeQuoteDesignerItem`, params)
}

function create_pm_quote_price(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/vendor/createPmQuotePrice`, params);
}

function get_quote_room(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/quote/getQuotesRoom`, params);
}

function get_duration(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getDuration`, params);
}

function get_pm_quote_price(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getPmQuotePrice`, params);
}

function get_quote_room_item(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/quote/getQuoteRoomItem`, params);
}

function get_pm_detail(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getPmInfo`, params);
}

function update_pm_detail(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/vendor/updatePmDetail`, params);
}

function get_designer_detail(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/vendor/getDesignerInfo`, params);
}

function update_designer_detail(params) {
    return makeRequest('post', `${BASE_URL_ADMIN}/api/vendor/updateDesignerDetail`, params);
}

function get_payment_detail(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/project/getPaymentDetail`, params);
}

function get_advert_position(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/setting/advert`, params);
}
function get_vouchers_by_quote(params) {
    return makeRequest('get', `${BASE_URL_ADMIN}/api/supplier/vouchers/list`, params)   
}
export default {
    get_room_types,
    get_designer_detail,
    get_payment_detail,
    update_designer_detail,
    update_pm_detail,
    get_quote_room,
    get_pm_detail,
    get_duration,
    get_pm_quote_price,
    remove_quote_designer_item,
    create_pm_quote_price,
    upload_image,
    create_quote,
    update_quote,
    get_quote_by_id,
    update_price_item_vendor,
    update_price_item_quote_vendor,
    get_all_group,
    get_contractor_by_group,
    get_designer,
    get_pm,
    get_items_of_quotes,
    get_items_vendor,
    get_items_vendor_pagination,
    vendor_sign_in,
    get_vendor_by_token,
    get_quote_of_vendor,
    get_contractor_quote_detail,
    add_item_quote_vendor,
    get_items_vendor_group,
    vendor_accept_quote,
    vendor_decline_quote,
    check_quote_vendor_state,
    get_contractor_detail,
    update_contractor_detail,
    vendor_get_projects,
    designer_get_projects,
    pm_get_projects,
    get_all_designer_items,
    add_new_quote_designer_item,
    get_quote_designer_items,
    get_quote_room_item,
    get_live_bid_of_designer,
    get_live_bid_of_pm,
    get_advert_position,
    get_vouchers_by_quote,
    get_designer_items_to_add
}